import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AppSettingsService} from '../../services/app-settings.service';
import {DateMethods, Option, StaticMethods} from '../../model/GeneralModels';

@Component({
  selector: 'app-normal-calender',
  template: `
    <div class="form-group">
      <div class="col-12" [formGroup]="date">
        <label for="form"><h4>{{settings.translateEnglish(fieldName)}}</h4></label>
        <br>
        <div class="col-md-4 col-sm-4">
          <select class="form-control" placeholder="سال" formControlName="year" (change)="onDateChange(); setDates();">
            <option *ngFor="let year of years" value="{{year}}" >{{year}}</option>
          </select>
        </div>
        <div class="col-md-4 col-sm-4">
          <select class="form-control" placeholder="ماه" formControlName="month" (change)="onDateChange(); setDates(); ">
            <option *ngFor="let month of months" value="{{month.value}}" >{{month.label}}</option>
          </select>
        </div>
        <div class="col-md-4 col-sm-4">
          <select class="form-control" placeholder="روز" formControlName="day" (change)="onDateChange()">
            <option *ngFor="let day of days" value="{{day}}">{{day}}</option>
          </select>
        </div>


      </div>
    </div>
  `,
  styleUrls: ['./normal-calender.component.css'],
  styles: [`
    select {
      width: 100%;
      height: 100%;
    }
  `]
})
export class NormalCalenderComponent
  implements OnInit, OnChanges {
  @Input() Group: FormGroup;
  @Input() AppSettings: AppSettingsService;
  @Input() fieldName: string;
  @Input() fieldLabel: string;
  @Input() options: any[];
  @Output() OnChange = new EventEmitter<File>();
  @Input() even: boolean;
  @Input() Icon: boolean;
  @Input() dateValue: boolean;
  datePickerConfig: any;
  date = this.fb.group({
    year: ['', Validators.required],
    month: ['', Validators.required],
    day: ['', Validators.required],
  });
  //
  years: any[] = [];
  days: any[] = [];
  months: Option[] = [];
  @Input() maxYear: number;
  @Input() minYear: number;

  persianDate: any;

  constructor(private fb: FormBuilder, public settings: AppSettingsService) {
  }

  ngOnInit() {
    this.generateList();
  }

  generateList() {
    const today = DateMethods.getJalaliDate(new Date());
    const maxYear = !this.maxYear ? 1399 : this.maxYear;
    const minYear = !this.minYear ? 1329 : this.minYear;
    this.setYears(minYear, maxYear);
    this.setMonths();
    this.setDates();
  }

  onChangeCallback(event) {
    this.OnChange.emit(event.target.selectedOptions.item(0).value);
  }

  onDateChange() {
    console.log(this.date.value);
    console.log(this.date.valid);
    if (this.date.valid) {
      this.Group.controls[this.fieldName].patchValue(
        DateMethods.getGeorgianDate(this.date.controls.year.value +
          '-' + this.date.controls.month.value + '-' + this.date.controls.day.value)
      );
    } else {
      this.Group.controls[this.fieldName].patchValue('');
    }
    console.log(this.Group.controls[this.fieldName].value);
  }

  setYears(startY, endY) {
    this.years = [];
    for (let i = startY; i < endY + 1; i++) {
      this.years[this.years.length] = i + '';
    }
    console.log(this.years);
  }

  setMonths() {
    const listMonths = [
      'فروردین',
      'اردیبهشت',
      'خرداد',
      'تیر',
      'مرداد',
      'شهریور',
      'مهر',
      'آبان',
      'آذر',
      'دی',
      'بهمن',
      'اسفند'
    ];
    this.months = [];
    for (let i = 0, l = listMonths.length; i < l; i++) {
      this.months[this.months.length] = new Option(listMonths[i], i + 1);
    }
  }

  setDates() {
    const days = [];
    let maxDay = 0;
    console.log(this.date.value);
    if (this.date.controls.month.valid && this.date.controls.year.valid) {
      const monthNumber = parseInt(this.date.controls.month.value, 10);
      const yearNumber = parseInt(this.date.controls.year.value, 10);
      console.log(monthNumber, yearNumber);
      if (monthNumber > 0 && monthNumber < 6) {
        maxDay = 30;
      } else {
        if (monthNumber === 12) {
          if (yearNumber % 4 === 0) {
            maxDay = 30;
          } else {
            maxDay = 29;
          }
        } else {
          maxDay = 31;
        }
      }
      for (let i = 1; i <= maxDay; i++) {
        days[i - 1] = i + '';
      }
      console.log(days);
      this.days = days;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dateValue.currentValue && changes.dateValue.currentValue !== changes.dateValue.previousValue) {
      const persianDate = DateMethods.getJalaliDate(this.dateValue);
      console.log(persianDate);
      const year = persianDate.split('/')[0];
      const month = persianDate.split('/')[1];
      const day = persianDate.split('/')[2];
      console.log(year, month, day);
      this.date.controls.year.patchValue(year);
      this.date.controls.month.patchValue(month);
      this.setDates();
      this.date.controls.day.patchValue(day);
    }
  }

}
